import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from '@/environments/environment';
import {
  AiSolutionSearchBody,
  AiSolutionSearchRequest,
  AiSolutionSearchResponse,
} from '@/app/interfaces/new-ai-solution-usage';

const api = axios.create({
  baseURL: `${environment.url}/api/aurora`,
  withCredentials: true,
});

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  async search<TResponse>(data: Record<string, unknown>): Promise<TResponse> {
    const response = await api.post<TResponse>('/busqueda', data, { withCredentials: true });
    return response.data;
  }

  async searchAiSolutions(search: string): Promise<AiSolutionSearchBody> {
    const request: AiSolutionSearchRequest = {
      busqueda: 'soluciones',
      search,
    };

    const response = await api.post<AiSolutionSearchResponse>('/busqueda', request, { withCredentials: true });

    return this.normalizeAiSolutionsSearchResponse(response.data);
  }

  private normalizeAiSolutionsSearchResponse(response: AiSolutionSearchResponse): AiSolutionSearchBody {
    const body = 'body' in response ? response.body : response;

    return {
      ...body,
      data: body.data.map((solution) => ({
        ...solution,
        descripcion: solution.descripcion ?? solution.description ?? null,
      })),
    };
  }
}
